module.exports = __webpack_public_path__ + "img/about02.9878dd31.jpg";